import { useContext, useEffect, useState } from "react";
import ChallengesShow from "./ChallengesShow";
import {
  BrandTheme,
  ChallengesOfflineProps,
  ICriteria,
  QuestThemeData,
} from "../types/Challenges.type";
import QuestContext from "../../../../components/QuestWrapper";
import { ThemeManager } from "./ThemeManager";

export const ChallengesOffline = ({
  styleConfig,
  offlineFormData = [],
  QuestThemeData,
  BrandThemeData,
  isGradientBackground,
  gradientBackgroundColor,
  showSvg,
  customSvg,
  showFooter = true,
}: ChallengesOfflineProps) => {
  const { themeConfig } = useContext(QuestContext.Context);
  const [suggestions, setSuggestions] = useState<ICriteria[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [questThemeData, setQuestThemeData] = useState<QuestThemeData>({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: [],
  });
  const [brandTheme, setBrandTheme] = useState<BrandTheme>({
    accentColor: "",
    background: "",
    borderRadius: "",
    buttonColor: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: "",
  });

  const themeManager = new ThemeManager(
    BrandThemeData,
    styleConfig || {},
    themeConfig || {},
    QuestThemeData
  );

  useEffect(() => {
    let filteredSuggestions = offlineFormData.filter(
      (criteria) =>
        criteria.title &&
        criteria.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setSuggestions(filteredSuggestions);
  }, [searchTerm, offlineFormData]);

  return (
    <div>
      {suggestions && (
        <ChallengesShow
          suggestions={suggestions}
          setSearchTerm={setSearchTerm}
          themeManager={themeManager}
          isGradientBackground={isGradientBackground}
          gradientBackgroundColor={gradientBackgroundColor}
          showSvg={showSvg}
          customSvg={customSvg}
          showFooter={showFooter}
        />
      )}
    </div>
  );
};